import React from "react";
const map = {
  pending: { bg: "bg-[#FFD600]", text: "text-black", label: "PENDING" },
  paid: { bg: "bg-[#FF6A00]", text: "text-white", label: "PAID" },
  approved: { bg: "bg-[#00C853]", text: "text-white", label: "APPROVED" },
  rejected: { bg: "bg-[#FF3333]", text: "text-white", label: "REJECTED" },
  processing: { bg: "bg-[#FF6A00]", text: "text-white", label: "PROCESSING" },
  done: { bg: "bg-[#00C853]", text: "text-white", label: "DONE" },
  failed: { bg: "bg-[#FF3333]", text: "text-white", label: "FAILED" },
  cancelled: { bg: "bg-zinc-300", text: "text-black", label: "CANCELLED" },
};

export default function StatusBadge({ status, large = false }) {
  const s = map[status] || { bg: "bg-zinc-100", text: "text-black", label: String(status).toUpperCase() };
  const cls = large ? "px-3 py-1.5 text-xs" : "px-2 py-1 text-[10px]";
  return (
    <span data-testid={`status-${status}`} className={`inline-flex items-center font-mono uppercase tracking-widest font-bold border border-black ${cls} ${s.bg} ${s.text}`}>
      {s.label}
    </span>
  );
}

